module.exports = __webpack_public_path__ + "static/media/inspect_reversed_white_circle_black_m.a98c6c9b.png";